export function ensureHttpsUrl(value) {
  const raw = (value || "").trim();
  if (!raw) return "";

  const hasScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(raw);
  if (!hasScheme) return `https://${raw}`;

  if (/^https:\/\//i.test(raw)) return raw;

  return raw.replace(/^[a-z][a-z0-9+.-]*:\/\//i, "https://");
}
